import { useNavigate } from "react-router-dom";

// ── Formatters ────────────────────────────────────────────────────────────────

export function fmt(n: number) {
    return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(n);
}

export function fmtDate(d: string) {
    return new Date(d).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "short",
    });
}

// ── Panel ─────────────────────────────────────────────────────────────────────

export function Panel({
    children,
    className = "",
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return <div className={`panel ${className}`}>{children}</div>;
}

// ── SectionHeader ─────────────────────────────────────────────────────────────

export function SectionHeader({ title, meta, action }: { title: string; meta?: React.ReactNode; action?: React.ReactNode }) {
    return (
        <div className="section-header">
            <div className="section-header__left">
                <h3 className="section-header__title">{title}</h3>
                {meta && <span className="section-header__meta">{meta}</span>}
            </div>
            {action}
        </div>
    );
}

// ── StatCard ──────────────────────────────────────────────────────────────────

interface StatCardProps {
    icon: React.ReactNode;
    label: string;
    value: string;
    sub?: string;
    accent?: string;
    to?: string;
    toState?: object;
}

export function StatCard({ icon, label, value, sub, accent, to, toState }: StatCardProps) {
    const navigate = useNavigate();
    return (
        <div
            className="stat-card"
            onClick={to ? () => navigate(to, { state: toState }) : undefined}
            style={to ? { cursor: "pointer" } : undefined}
        >
            <div
                className="stat-card__icon"
                style={{ background: accent + "18", color: accent }}
            >
                {icon}
            </div>
            <div>
                <div className="stat-card__value">{value}</div>
                <div className="stat-card__label">{label}</div>
                {sub && <div className="stat-card__sub">{sub}</div>}
            </div>
        </div>
    );
}

// ── MiniBar ───────────────────────────────────────────────────────────────────

export function MiniBar({
    value,
    max,
    color,
}: {
    value: number;
    max: number;
    color: string;
}) {
    return (
        <div className="mini-bar">
            <div
                className="mini-bar__fill"
                style={{
                    width: `${Math.min(100, (value / max) * 100)}%`,
                    background: color,
                }}
            />
        </div>
    );
}
